import localStorageEx from 'bundles/common/utils/localStorageEx';

export const VIEW_ONLY = 'view-only';
export const EDIT_MODE = 'edit-mode';
const INACTIVE = 'inactive';

const AAL_SESSION_MODE_KEY = 'aal_session_mode';

const saveModeToLocalStorage = (mode: string) => {
  localStorageEx.setItem(AAL_SESSION_MODE_KEY, mode, JSON.stringify);
};

export const clearModeInLocalStorage = () => {
  localStorageEx.removeItem(AAL_SESSION_MODE_KEY);
};

export const setEditModeInLocalStorage = () => {
  saveModeToLocalStorage(EDIT_MODE);
};

export const setViewOnlyModeInLocalStorage = () => {
  saveModeToLocalStorage(VIEW_ONLY);
};

export const isAALViewOnlyActive = () => {
  return localStorageEx.getItem(AAL_SESSION_MODE_KEY, JSON.parse, INACTIVE) === VIEW_ONLY;
};
